<template>
<router-view />
</template>

<script>
export default {
  name: 'PMFAnalysis',
  routeInfo: {
    label: 'PMF源解析',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/index.vue